// extracted by mini-css-extract-plugin
export default {"errorWrapper":"styles_errorWrapper__ZbJTR","errorText":"styles_errorText__YPBMY"};